import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";

export class customFromToCtrl implements IController {

  currentTimeSelected: any;
  onChange: Function;

  private invalidSelection: any;
  private from: any;
  private to: any;

  /* @ngInject */
  constructor(private $mdDialog, private moment) {
  }

  $onInit() {
    this.invalidSelection = false;

    if (this.currentTimeSelected) {
      this.from = new Date(this.currentTimeSelected.from);
      this.to = new Date(this.currentTimeSelected.to);
    }
    else {
      this.from = new Date(this.moment().add('days', -1).hour(0).minute(0).second(0).valueOf());
      this.to = new Date(this.moment().hour(0).minute(0).second(-1).valueOf());
    }

  }

  confirm() {
    if (this.from.getTime() <= this.to.getTime()) {
      this.$mdDialog.hide({
        from: this.from,
        to: this.to
      })
    }
    else {
      this.invalidSelection = true;
    }
  }

  change() {
    if (_.isEqual(this.invalidSelection, true)) {
      this.invalidSelection = false;
    }
  }

}

angular
  .module('bringoz.admin.commons')
  .component('customFromTo', {
    bindings: {
      currentTimeSelected: '<?',
      onChange: '&'
    },
    template: require('./custom-from-to.html').default,
    controller: customFromToCtrl
  });

